// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"kK-z","tooltipWrapper":"lK-z","icon":"mK-z","tooltip":"nK-z","content":"oK-z"};